import React from 'react';
export const StorySection = () => {
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-182">
      <div className="max-w-[720px] mx-auto" data-id="element-183">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-184">
          Does This Sound Familiar?
        </h2>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8]" data-id="element-185">
          <p className="mb-5" data-id="element-186">
            You sleep eight hours, but you wake up already tired. You can't
            quite name what's wrong — only that something has been off for a
            long time.
          </p>
          <p className="mb-5" data-id="element-187">
            Your tests come back normal. Your doctor reassures you. And yet, by
            mid-afternoon, your energy is gone. You feel foggy. Bloated. Quietly
            anxious. A version of yourself you don't fully recognize.
          </p>
          <p className="mb-5" data-id="element-188">
            You've started waking at 3am for no clear reason. You feel
            emotionally flat, then irritable, then exhausted. You've tried
            sleeping more, eating cleaner, slowing down — and the symptoms still
            find you.
          </p>
        </div>

        <blockquote className="font-playfair italic text-[24px] md:text-[28px] text-primary text-center py-2 my-4 max-w-[600px] mx-auto border-none" data-id="element-189">
          "Everything is normal," they said.
        </blockquote>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8] mb-4" data-id="element-190">
          <p className="mb-5" data-id="element-191">
            Maybe it began after a stressful season. Maybe after stopping the
            pill. Maybe after a baby, a move, a loss — or simply too many years
            of doing too much. Whatever set it in motion, the feeling is the
            same: you've been surviving, not living.
          </p>
          <p className="mb-5" data-id="element-192">And the hardest part isn't the symptoms.</p>
        </div>

        <div className="flex flex-col gap-2" data-id="element-193">
          <p className="font-lato font-bold text-[18px] text-medium text-left m-0 p-0" data-id="element-194">
            The hardest part isn't the symptoms.
          </p>
          <p className="font-lato font-bold text-[18px] text-medium text-left m-0 p-0" data-id="element-195">
            It's feeling unseen — and being told everything is fine when it
            isn't.
          </p>
        </div>
      </div>
    </section>;
};